import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebook, FaTwitter, FaInstagram, FaLinkedin } from 'react-icons/fa';
import HoneycombLogo from './HoneycombLogo';
import './Footer.css';

const Footer = () => {
    return (
        <footer className="footer">
            <div className="container">
                <div className="footer-content">
                    <div className="footer-section">
                        <div className="footer-logo">
                            <HoneycombLogo size={36} />
                            <span className="logo-text">SkillHive Admin</span>
                        </div>
                        <p className="footer-description">
                            Admin portal for managing service providers and job requests.
                        </p>
                    </div>

                    <div className="footer-section">
                        <h4>Management</h4>
                        <ul>
                            <li><Link to="/job-requests">Job Requests</Link></li>
                            <li><Link to="/workers">Workers</Link></li>
                            <li><Link to="/add-worker">Add Worker</Link></li>
                            <li><Link to="/">Dashboard</Link></li>
                        </ul>
                    </div>

                    <div className="footer-section">
                        <h4>Resources</h4>
                        <ul>
                            <li><Link to="/">Documentation</Link></li>
                            <li><Link to="/">Support</Link></li>
                            <li><Link to="/">API</Link></li>
                            <li><Link to="/">Settings</Link></li>
                        </ul>
                    </div>

                    <div className="footer-section">
                        <h4>Legal</h4>
                        <ul>
                            <li><Link to="/">Privacy Policy</Link></li>
                            <li><Link to="/">Terms of Service</Link></li>
                            <li><Link to="/">Security</Link></li>
                            <li><Link to="/">Compliance</Link></li>
                        </ul>
                    </div>
                </div>

                <div className="footer-bottom">
                    <p>&copy; 2024 SkillHive Admin. All rights reserved.</p>
                    <div className="social-links">
                        <a href="#facebook" aria-label="Facebook"><FaFacebook /></a>
                        <a href="#twitter" aria-label="Twitter"><FaTwitter /></a>
                        <a href="#instagram" aria-label="Instagram"><FaInstagram /></a>
                        <a href="#linkedin" aria-label="LinkedIn"><FaLinkedin /></a>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
